module.exports = __webpack_public_path__ + "static/media/indent.1bf10354.svg";